import React from 'react';

const DotCheckbox = ({ checked, onChange, theme }) => {
  const size = 18;
  const outerBorder =
    theme === 'dark'
      ? '2px solid rgba(203,213,225,0.06)'
      : '2px solid rgba(100,116,139,0.4)';
  const bg = checked ? (theme === 'dark' ? '#34d399' : '#059669') : 'transparent';
  const innerSize = 8;

  const style = {
    width: size,
    height: size,
    minWidth: size,
    minHeight: size,
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxSizing: 'border-box',
    background: bg,
    border: checked ? 'none' : outerBorder,
  };

  const inner = {
    width: innerSize,
    height: innerSize,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.95)',
  };

  return (
    <div
      role="checkbox"
      aria-checked={checked}
      tabIndex={0}
      onClick={(e) => {
        e.stopPropagation();
        onChange();
      }}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          onChange();
        }
      }}
      style={style}
    >
      {checked && <div style={inner} />}
    </div>
  );
};

export default DotCheckbox;